import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component({
  name: 'bpc-html-to-printer',
  components: {},
})
export default class HtmlToPrinter extends Vue {
  @Prop(Boolean) readonly printPreview: boolean;
  @Prop(Boolean) readonly hidePrintButton: boolean;
  @Prop(String) readonly printByElementId: string;
  @Prop({ type: String, default: 'Print' }) readonly title: string;
  @Prop({ type: String, default: 'Print' }) readonly printButtonLabel: string;
  @Prop({ type: String, default: 'print' }) readonly printButtonIcon: string;
  @Prop({ type: String, default: '' }) readonly buttonClass: string;
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  readonly buttonProperties: object;
  @Prop({ type: Number, default: 500 }) readonly printWindowHeight: string;
  @Prop({ type: Number, default: 600 }) readonly printWindowWidth: string;

  printing: boolean = false;
  printingWindow: Window = null;

  mounted() {
    this.random = this.generateUUIDv4();
  }

  beforeUnmount() {
    if (this.printingWindow.closed) {
      console.log('beforeUnmount2');
      this.windowClosed = true;
    }
  }

  generateUUIDv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  random = 'random-code';

  windowClosed: boolean = false;

  get printElementSlotContainerId(): string {
    return `html-to-print-element-${this.random}`;
  }

  get printElementId(): string {
    if (this.printByElementId) {
      return this.printByElementId;
    }
    return this.printElementSlotContainerId;
  }

  async printContent() {
    this.printingWindow = null;
    this.$emit('start-printing');
    const prtHtml = document.getElementById(this.printElementId).innerHTML;
    const stylesElArray = [...document.querySelectorAll('link[rel="stylesheet"], style')];
    const stylesHtml = stylesElArray.reduce((html, node) => `${html}${node.outerHTML}`, '');

    this.printingWindow = window.open(
      '',
      '',
      `left=0,top=0,width=${this.printWindowWidth},height=${this.printWindowHeight},toolbar=0,scrollbars=0,status=0`,
    );

    if (
      !this.printingWindow ||
      this.printingWindow.closed ||
      typeof this.printingWindow.closed == 'undefined'
    ) {
      this.$emit('blocked-window');
      return false;
    }

    await this.$nextTick();

    this.$emit('opened-window');

    this.listenPrintEvents();

    this.printingWindow.document.write(
      `<!DOCTYPE html><html><head>${stylesHtml}<title>${this.title}</title></head><body class="html-to-printer">${prtHtml}</body></html>`,
    );

    // NOTE: if we dont set a timeout the styles fails on print
    // TODO add an observer in the printingWindow to know
    // when it is ready instead of this timeout
    setTimeout(() => {
      this.$nextTick().then(() => {
        this.$emit('rendered-document');
        if (!this.printPreview) {
          this.printingWindow.document.close(); // necessary for IE >= 10
          this.printingWindow.focus(); // necessary for IE >= 10*/
          this.printingWindow.print();
          this.printingWindow.close();
          this.windowClosed = true;
        }
      });
    }, 1200);

    return true;
  }

  listenPrintEvents() {
    setInterval(() => {
      if (this.printingWindow && this.printingWindow.closed) {
        this.windowClosed = true;
      } else {
        this.windowClosed = false;
      }
    }, 1000);
  }

  @Watch('windowClosed')
  onWindowClosedChange(val) {
    if (val) {
      this.$emit('closed-window');
    }
  }
}
